import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-profile",
  "use": "foquz-icon-vue-profile-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-profile\"><path d=\"M15 15v-1a3 3 0 00-3-3H4a3 3 0 00-3 3v1M11 4a3 3 0 11-6 0 3 3 0 016 0z\" stroke=\"#679\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol